<template>
  <div style="text-align: left">
    <div class="sectionKoko">
      <div class="container">
        <div class="row mt-2">
          <div class="sectionHead">
            Online
          </div>
        </div>
        <div class="row mt-1">
          <div v-for="(item, $index) in list" :key="$index" class="post-item col-6 ">

            <div class="text-center mt-1">
              <a :href="item.siteUrl">
                <div style=""> &nbsp;
                  <!--        <div v-if="merchantData.doesOffline" class="text-right" style="background:#F3D0E4; margin-top:140px; margin-left:50%; margin-right: 5%;  height: 20px; font-size: 12px; font-weight: bolder;" >-->
                  <!--          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">-->
                  <!--            <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>-->
                  <!--          </svg> IN STORE-->
                  <!--        </div>-->
                  <img :src="item.rectBannerUrl" style="height:auto; width:100%;" alt=""/>
                </div>
                <!--    {{ mName }}-->
                {{ item.merchantName }}
              </a>
            </div>


          </div>
        </div>
        
      </div>

    </div>
  </div>

</template>

<script>

import {ref} from "vue";
import axios from "axios";


// Interop vue 2 component to vue 3
import toVue3 from 'vue-2-3/to-vue-3'
import Vue2 from 'vue2'
import * as Vue3 from 'vue'

toVue3.register(Vue2, Vue3);

const api = 'http://localhost:3100/merchantcat'

export default {
  name: "MobChannelViewOnline",
  data() {
    return {
      finalId:0
    }
  },
  setup() {
    const page = ref(1)
    const list = ref([])
    let dataId = 0
    // let docArray = new Map([])

    const infiniteHandler = async ($state) => {

      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      // 2 is type - Channel
      const {data} = await axios.post(api, "{\"Page\": "  +dataId+ ", \"Type\": 2, \"ChannelId\": 1, \"CategoryName\":\""+params.get("cattype")+"\"}")
      // console.log(docArray[0].merchantName)
      // " + +
      // console.log(this.data().finalId)
      // let test=JSON.parse(list.value);
      // console.log("Woah"+test)
      // console.log(test)
      // console.log(data)
      // list.value.values().

      if (data) {
        page.value += 1
        list.value.push(...data)
        dataId=data[data.length-1].id
        $state.loaded()
      } else {
        console.log("End of the line")
        $state.complete()
      }
    }

    return {
      infiniteHandler,
      slots: {
        noMore: "Test"
      },
      list
    }
  },
}
</script>

<style scoped>

.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #022078;
  border: 0;
  height: 50px;
  width: 100%;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}


.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}
</style>